<template>
  <profile-card header-color="blue" class="map-sidebar">
    <template slot="header">
      <div class="card-icon"><md-icon>location_on</md-icon></div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <p  class="sidebar-title h5-p">
          Map Center Point
        </p>
        <label class="sidebar-title-label">(Optional)</label>
      </div>
      <md-field>
        <label>Street Address</label>
        <md-input v-model="streetAddress" type="text"></md-input>
      </md-field>
      <md-field>
        <label>ZIP Code</label>
        <md-input v-model="zipCode" type="text"></md-input>
      </md-field>
      <md-field>
        <label>Radius, max 100 miles</label>
        <md-input v-model="radius" type="text"></md-input>
      </md-field>
    </template>
    <template slot="footer">
      <md-button class="md-info md-block access-button btn-sm" @click="access"
        >Calculate
      </md-button>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from '@/components';
import axios from 'axios';

export default {
  name: 'sidebar-map',
  props: {},
  components: { ProfileCard },
  data() {
    return {
      streetAddress: '',
      zipCode: '',
      radius: '',
    };
  },
  methods: {
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    access: async function() {
      if (this.streetAddress && this.zipCode && this.radius) {
        let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
        );

        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
            {},
            {
              params: {
                session_id: currentSession,
                profile_id: this.profileId ? this.profileId : '0',
                industry: this.getData(this.mIndustry),
                map_center: `${encodeURIComponent(this.streetAddress)}`,
                map_center_zip: this.zipCode,
                radius: this.radius,
                area: 0,
                zips: '0',
                type: 'imr',
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
              );
              throw new Error(
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
              );
            }
            const { id } = res.data;
            this.$store.commit('M_SET_PROFILE_ID', id);
            this.$store.commit(
              'M_SET_MARKET_AREA',
              `${this.radius} miles away from ${this.streetAddress}, ${this.zipCode} [map_center]`
            );
          });
      }
    },
  },
  computed: {
    profileId() {
      return this.$store.getters.mProfileId;
    },
  },
};
</script>
<style lang="scss"></style>
